/* eslint-disable react/prop-types */
import CancelIcon from "@mui/icons-material/Cancel";
import {
  Autocomplete,
  Box,
  Chip,
  FormControl,
  FormHelperText,
  Grid,
  MenuItem,
  Select,
  Stack,
  TextField,
  TextareaAutosize,
  Typography,
} from "@mui/material";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import { useEffect, useMemo, useState } from "react";
import { MenuProps } from "../../utils/constants";

const CustomFieldForm = ({
  listField,
  data,
  errorValues,
  onChange,
  onError,
  listOptionDic,
}) => {
  const [dataState, setDataState] = useState();
  const [errors, setErrors] = useState();
  const checkDate = useMemo(() => {
    return {
      maxDate: "Thời gian phải trước năm 2200",
      minDate: "Thời gian phải sau năm 1800",
      invalidDate: "Thời gian định dạng sai",
    };
  }, []);

  useEffect(() => {
    setErrors(errorValues);
  }, [errorValues]);

  useEffect(() => {
    setDataState(data);
  }, [data]);

  const handleChangeValueInput = (name) => (e) => {
    let { value } = e.target;
    setDataState((prev) => {
      return {
        ...prev,
        [name]: value,
      };
    });
    onChange?.({ name: name, value: value });
  };

  const handleChangeDate = (name) => (value) => {
    setDataState((prev) => {
      return {
        ...prev,
        [name]: value,
      };
    });
    if (dayjs(value)?.isValid()) {
      setErrors((prev) => ({
        ...prev,
        [name]: "",
      }));
      onError({ name: name, value: "" });
    }
    onChange?.({ name: name, value: value });
  };

  const handleOnErrorDate = (name) => (error) => {
    if (error) {
      setErrors((prev) => ({
        ...prev,
        [name]: checkDate[error],
      }));
      onError({ name: name, value: checkDate[error] });
    } else {
      setErrors((prev) => ({
        ...prev,
        [name]: "",
      }));
      onError({ name: name, value: "" });
    }
  };
  const handleToClearDate = (name) => (e) => {
    setDataState((prev) => ({
      ...prev,
      [name]: null,
    }));
    onChange?.({ name: name, value: null });
  };

  const handleOnFocus = (name) => (e) => {
    e.stopPropagation();
    setErrors((prev) => ({
      ...prev,
      [name]: "",
    }));
    onError({ name: name, value: "" });
  };

  const handleInputTypeNumber = (name) => (e) => {
    let value = e.target.value;
    value = value.replace(/[^\d.]/g, "");

    let formattedNumber = "";
    if (value && !isNaN(parseFloat(value))) {
      formattedNumber = parseFloat(value).toLocaleString("en-US");
    }
    setDataState((prev) => ({
      ...prev,
      [name]: formattedNumber ? formattedNumber : "",
    }));
    onChange?.({ name: name, value: formattedNumber ? formattedNumber : "" });
  };

  //float
  const handleValueNumberInput = (name) => (e) => {
    const resultString = e.target.value.replace(/[^0-9.]/g, "");
    setDataState((prev) => {
      return {
        ...prev,
        [name]: resultString,
      };
    });
  };
  const handleOnBlurNumber = (name) => (e) => {
    let value = e.target.value;
    value = value.replace(/[^\d.]/g, "");

    let formattedNumber = "";
    if (value && !isNaN(parseFloat(value))) {
      formattedNumber = parseFloat(value).toLocaleString("en-US", {
        minimumFractionDigits: 0,
        maximumFractionDigits: 3,
      });
    }
    setDataState((prev) => ({
      ...prev,
      [name]: formattedNumber ? formattedNumber : "",
    }));
    onChange?.({ name: name, value: formattedNumber ? formattedNumber : "" });
  };

  const handleChangeAutoComplete = (name, unicode) => (e, newValue) => {
    setDataState((prev) => ({
      ...prev,
      [name]: newValue ? newValue[unicode] : null,
    }));
    onChange?.({ name: name, value: newValue ? newValue[unicode] : null });
  };
  const handleChangeMultiple = (key) => (e) => {
    let { value } = e.target;
    setDataState((prev) => ({
      ...prev,
      [key]: value?.length > 0 ? value : [],
    }));
    onChange?.({ name: key, value: value?.length > 0 ? value : [] });
  };
  const handleToDelete = (key, value) => (e) => {
    let newArr = dataState[key].filter((item) => item !== value);
    setDataState((prev) => ({
      ...prev,
      [key]: newArr || [],
    }));
    onChange?.({ name: key, value: newArr || [] });
  };
  const handleKeyDown = (event) => {
    // Kiểm tra xem phím đã được nhấn có phải là "."
    if (event.key === ".") {
      event.preventDefault(); // Loại bỏ phím "." nếu có
    }
  };
  return (
    <Grid container spacing={2} sx={{ textAlign: "left" }}>
      {listField?.length > 0 &&
        listField?.map(
          (field) =>
            !field?.isHidden && (
              <Grid
                item
                key={field?.key}
                xs={field.xs}
                md={field.md}
                lg={field.lg}
              >
                <Typography
                  fontSize={"0.75rem"}
                  color={"#000000"}
                  fontWeight={500}
                >
                  {field?.nameComponent ? field?.nameComponent : field?.name}{" "}
                  {field?.required ? (
                    <span style={{ color: "red" }}>*</span>
                  ) : (
                    ""
                  )}
                </Typography>
                {field?.type == "text" && (
                  <TextField
                    fullWidth
                    name={field?.key}
                    value={dataState?.[field?.key] || ""}
                    error={errors ? !!errors?.[field?.key] : false}
                    placeholder={`Nhập ${field?.name?.toLowerCase()}`}
                    helperText={errors?.[field?.key]}
                    onChange={handleChangeValueInput(field?.key)}
                    inputProps={{
                      maxLength: field?.maxLength,
                    }}
                    onFocus={handleOnFocus(field?.key)}
                  />
                )}
                {field?.type == "number" && (
                  <TextField
                    fullWidth
                    name={field?.key}
                    value={dataState?.[field?.key] || 0}
                    error={errors ? !!errors?.[field?.key] : false}
                    placeholder={`Nhập ${field?.name?.toLowerCase()}`}
                    helperText={errors?.[field?.key]}
                    onChange={handleChangeValueInput(field?.key)}
                    type="number"
                    onFocus={handleOnFocus(field?.key)}
                    inputProps={{ pattern: "[0-9]*" }}
                    onKeyDown={handleKeyDown}
                    InputProps={{
                      inputProps: {
                        style: { textAlign: "right" },
                      },
                    }}
                  />
                )}
                {field?.type == "textNumber" && (
                  <TextField
                    fullWidth
                    name={field?.key}
                    value={dataState?.[field?.key] || 0}
                    error={errors ? !!errors?.[field?.key] : false}
                    placeholder={`Nhập ${field?.name?.toLowerCase()}`}
                    helperText={errors?.[field?.key]}
                    onChange={handleInputTypeNumber(field?.key)}
                    onFocus={handleOnFocus(field?.key)}
                    disabled={field?.disabled ? true : false}
                    inputProps={{
                      style: {
                        textAlign: "right",
                      },
                    }}
                  />
                )}
                {field?.type == "textArea" && (
                  <TextField
                    fullWidth
                    name={field?.key}
                    value={dataState?.[field?.key] || ""}
                    error={errors ? !!errors?.[field?.key] : false}
                    placeholder={`Nhập ${field?.name?.toLowerCase()}`}
                    helperText={errors?.[field?.key]}
                    onChange={handleChangeValueInput(field?.key)}
                    onFocus={handleOnFocus(field?.key)}
                    multiline
                    InputProps={{
                      inputComponent: TextareaAutosize,
                      rows: 3,
                    }}
                    inputProps={{
                      maxLength: field?.maxLength ? field?.maxLength : 255,
                    }}
                  />
                )}
                {field?.type == "textNumberFloat" && (
                  <TextField
                    fullWidth
                    name={field?.key}
                    value={dataState?.[field?.key] || 0}
                    error={errors ? !!errors?.[field?.key] : false}
                    placeholder={`Nhập ${field?.name?.toLowerCase()}`}
                    helperText={errors?.[field?.key]}
                    onChange={handleValueNumberInput(field?.key)}
                    onFocus={handleOnFocus(field?.key)}
                    inputProps={{
                      style: {
                        textAlign: "right",
                      },
                      pattern: "[0-9]*",
                    }}
                    onBlur={handleOnBlurNumber(field?.key)}
                  />
                )}
                {field?.type == "select" && !field?.multiple && (
                  <FormControl fullWidth>
                    <Select
                      sx={{ padding: "0.75rem" }}
                      name={field?.key}
                      value={
                        listOptionDic[field?.key]?.length > 0 &&
                        dataState &&
                        field?.key &&
                        dataState[field.key]
                          ? dataState[field.key]
                          : ""
                      }
                      displayEmpty
                      MenuProps={MenuProps}
                      error={errors ? !!errors?.[field?.key] : false}
                      onChange={
                        field?.onChange
                          ? field.onChange
                          : handleChangeValueInput(field?.key)
                      }
                      onFocus={handleOnFocus(field?.key)}
                      disabled={field?.disabled}
                      required={field?.required}
                      readOnly={field?.readOnly}
                    >
                      {field?.hasPlaceholder && (
                        <MenuItem
                          value={""}
                        >{`--- Chọn ${field?.name?.toLowerCase()} ---`}</MenuItem>
                      )}
                      {listOptionDic[field?.key] &&
                        listOptionDic[field?.key]?.length > 0 &&
                        listOptionDic[field?.key]?.map((item) => (
                          <MenuItem
                            key={item[field?.unicode]}
                            value={item[field?.unicode]}
                          >
                            {item[field?.labelKeyOption]}
                          </MenuItem>
                        ))}
                    </Select>
                    {errors?.[field?.key] && (
                      <FormHelperText sx={{ color: "red", fontSize: "12px" }}>
                        {errors?.[field?.key]}
                      </FormHelperText>
                    )}
                  </FormControl>
                )}
                {field?.type == "select" && field?.multiple && (
                  <FormControl fullWidth>
                    <Select
                      multiple
                      sx={{ padding: "0.75rem" }}
                      name={field?.key}
                      value={
                        listOptionDic[field?.key]?.length > 0 &&
                        dataState &&
                        field?.key &&
                        dataState[field.key]
                          ? dataState[field.key]
                          : []
                      }
                      MenuProps={MenuProps}
                      error={errors ? !!errors?.[field?.key] : false}
                      onChange={handleChangeMultiple(field?.key)}
                      onFocus={handleOnFocus(field?.key)}
                      disabled={field?.disabled}
                      required={field?.required}
                      readOnly={field?.readOnly}
                      renderValue={(selected) => {
                        return (
                          <Stack gap={1} direction="row" flexWrap="wrap">
                            {listOptionDic[field?.key]?.length > 0 &&
                              selected?.length > 0 &&
                              selected.map((value) => (
                                <Chip
                                  key={value}
                                  label={
                                    listOptionDic[field?.key].find(
                                      (item) => item?.[field?.unicode] == value
                                    )?.[field?.labelKeyOption]
                                  }
                                  onDelete={handleToDelete(field?.key, value)}
                                  deleteIcon={
                                    <CancelIcon
                                      onMouseDown={(event) =>
                                        event.stopPropagation()
                                      }
                                    />
                                  }
                                  sx={{
                                    fontSize: "0.75rem",
                                    height: "1.25rem",
                                  }}
                                />
                              ))}
                          </Stack>
                        );
                      }}
                    >
                      {field?.hasPlaceholder && (
                        <MenuItem
                          value={""}
                        >{`--- Chọn ${field?.name?.toLowerCase()} ---`}</MenuItem>
                      )}
                      {listOptionDic[field?.key] &&
                        listOptionDic[field?.key]?.length > 0 &&
                        listOptionDic[field?.key]?.map((item) => (
                          <MenuItem
                            key={item[field?.unicode]}
                            value={item[field?.unicode]}
                          >
                            {item[field?.labelKeyOption]}
                          </MenuItem>
                        ))}
                    </Select>
                    {errors?.[field?.key] && (
                      <FormHelperText sx={{ color: "red", fontSize: "12px" }}>
                        {errors?.[field?.key]}
                      </FormHelperText>
                    )}
                  </FormControl>
                )}
                {field?.type == "date" && (
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DatePicker
                      sx={{ width: "100%", textAlign: "right" }}
                      format="DD/MM/YYYY"
                      value={
                        dataState?.[field?.key]
                          ? dayjs(dataState?.[field?.key])
                          : null
                      }
                      onChange={handleChangeDate(field?.key)}
                      slotProps={{
                        field: {
                          clearable: true,
                          onClear: handleToClearDate(field?.key),
                        },
                        textField: {
                          name: field?.key,
                          error: errors ? !!errors?.[field?.key] : false,
                          helperText: errors?.[field?.key],
                          inputProps: {
                            style: {
                              textAlign: "center",
                            },
                          },
                        },
                      }}
                      onError={handleOnErrorDate(field?.key)}
                      minDate={dayjs("1800-01-01T00:00:00.000")}
                      maxDate={dayjs("2200-12-31T23:59:59.999")}
                    />
                  </LocalizationProvider>
                )}
                {field?.type == "autocomplete" && (
                  <Autocomplete
                    id={`combo-box-${field?.key}`}
                    options={listOptionDic[field?.key]}
                    getOptionLabel={(option) => option?.[field?.labelKeyOption]}
                    value={
                      listOptionDic[field?.key]?.find(
                        (option) =>
                          option?.[field?.unicode] === dataState?.[field?.key]
                      ) || null
                    }
                    onChange={
                      field?.onChange
                        ? field.onChange
                        : handleChangeAutoComplete(field?.key, field?.unicode)
                    }
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        placeholder={`Chọn ${field?.name?.toLowerCase()}`}
                        error={errors ? !!errors?.[field?.key] : false}
                        helperText={errors?.[field?.key]}
                      />
                    )}
                    renderOption={(props, options) => (
                      <Box
                        component="li"
                        {...props}
                        key={options?.id || options?.[field?.unicode]}
                      >
                        {options?.[field?.labelKeyOption]}
                      </Box>
                    )}
                    fullWidth
                    size="medium"
                    sx={{
                      ".MuiAutocomplete-input": {
                        padding: "3px 3px 3px 16px !important",
                      },
                    }}
                    disabled={field?.disabled}
                    readOnly={field?.readOnly}
                    onFocus={handleOnFocus(field?.key)}
                  />
                )}
                {field?.type == "dateYear" && (
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DatePicker
                      value={
                        dataState?.[field?.key]
                          ? dayjs(dataState?.[field?.key])
                          : null
                      }
                      views={["year"]}
                      onChange={handleChangeDate(field?.key)}
                      slotProps={{
                        textField: {
                          InputLabelProps: { shrink: true },
                          placeholder: "---Chọn năm---",
                          fullWidth: true,
                          inputProps: {
                            readOnly: true,
                          },
                        },
                        field: {
                          clearable: true,
                          onClear: handleToClearDate(field?.key),
                        },
                      }}
                    />
                  </LocalizationProvider>
                )}
              </Grid>
            )
        )}
    </Grid>
  );
};

export default CustomFieldForm;
